import React from 'react';
import Moment from 'moment';
import '../../css/card.css';

/**
 * PatientTrackingFollowUpDate Component
 * 
 * Displays the patient tracking follow-up date for results where examautocompleteyn='0'.
 * 
 * @component
 * @param {Object} props
 * @param {string} props.followUpDate - The follow-up date in ISO format
 * @param {boolean} [props.showLabel=true] - Whether to show the "Patient Tracking Follow Up Date" label
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {string} [props.dateFormat='MM/DD/YYYY'] - Moment.js date format string
 * 
 * @example
 * <PatientTrackingFollowUpDate 
 *   followUpDate="2025-09-24" 
 *   showLabel={true}
 *   dateFormat="MM/DD/YYYY"
 * />
 */
export const PatientTrackingFollowUpDate = ({ 
    followUpDate, 
    showLabel = true, 
    className = '',
    dateFormat = 'MM/DD/YYYY'
}) => {
    if (!followUpDate) {
        return null;
    }

    const formattedDate = Moment(followUpDate).format(dateFormat);

    return (
        <div className={`patient-tracking-follow-up-date ${className}`}>
            {showLabel && (
                <strong>Patient Tracking Follow Up Date: </strong>
            )}
            <span className="date-value">{formattedDate}</span>
        </div>
    );
};

export default PatientTrackingFollowUpDate;
